import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DomainMetadataVO, TopLevelDomainVO} from '../../../generate/TopLevelDomainVO';
import {ChangeVO} from '../../../generate/ChangeVO';

@Component({
  selector: 'meta-data',
  templateUrl: './meta-data.component.html',
  styleUrls: ['./meta-data.component.scss']
})
export class MetaDataComponent implements OnInit {
  @Input()
  domain: TopLevelDomainVO;
  @Input()
  lastchange: string;
  @Input()
  change: ChangeVO;
  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomainVO>();
  editmode: boolean;
  @Input()
  viewMode: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  edit(val) {
    this.editmode = val;
  }

  cancel(val) {
    this.edit(false);
  }

  metaData(metadata: DomainMetadataVO) {
    console.log(metadata);
    this.domain.metadata = metadata;
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }

}
